(function () {
  if (window.SstFeaturedEventVideoLoaded) return;
  window.SstFeaturedEventVideoLoaded = true;
  var mobileAccordionMedia = window.matchMedia('(max-width: 599px)');

  function initializeVideo(section) {
    if (!section || section.dataset.videoInitialized === 'true') return;

    var video = section.querySelector('.sst-featured-event__video');
    var button = section.querySelector('[data-featured-event-sound-toggle]');
    if (!video || !button) return;

    function updateButton() {
      var soundOn = !video.muted;
      button.dataset.soundOn = soundOn ? 'true' : 'false';
      button.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
      button.setAttribute('aria-label', soundOn ? 'Mute event video' : 'Unmute event video');
    }

    video.defaultMuted = true;
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    if (section.dataset.videoLoop === 'true') {
      video.loop = true;
      video.setAttribute('loop', '');
    }

    var playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(function () {});
    }

    button.addEventListener('click', function () {
      video.muted = !video.muted;

      if (video.paused) {
        var resumedPlayback = video.play();
        if (resumedPlayback && typeof resumedPlayback.catch === 'function') {
          resumedPlayback.catch(function () {});
        }
      }

      updateButton();
    });

    video.addEventListener('volumechange', updateButton);
    updateButton();
    section.dataset.videoInitialized = 'true';
  }

  function initializeVideos(root) {
    var sections = root.querySelectorAll('.sst-featured-event');
    sections.forEach(initializeVideo);

    if (root.classList && root.classList.contains('sst-featured-event')) {
      initializeVideo(root);
    }
  }

  function initializeAccordions(root) {
    var accordions = root.querySelectorAll('[data-featured-event-mobile-accordion]');
    accordions.forEach(function (accordion) {
      accordion.open = !mobileAccordionMedia.matches;
    });
  }

  function initializeSections(root) {
    initializeVideos(root);
    initializeAccordions(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeSections(document);
    });
  } else {
    initializeSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeSections(event.target);
  });

  function syncAccordions() {
    initializeAccordions(document);
  }

  if (typeof mobileAccordionMedia.addEventListener === 'function') {
    mobileAccordionMedia.addEventListener('change', syncAccordions);
  } else {
    mobileAccordionMedia.addListener(syncAccordions);
  }
})();
